export const CREATOR_MESSAGE_DRAFTS_KEY = "creator-message-drafts" as const;
